import {FileCreator, FileOpener, FileSaver, FileExplorer} from "./FileHandlers"
import PopupWindow from "./PopupWindow"

import Calculator from "./Calculator"
import Checkers from "./Checkers"
// import FakeApp from "./FakeApp"
import Help from "./Help"
import Maps from "./Maps"
import Minesweeper from "./Minesweeper"
import PokemonFinder from "./PokemonFinder"
import Othello from "./Othello"
import Paint from "./Paint"
import Notepad from "./Notepad"
import Pathfinder from "./Pathfinder"
import Screensavers from "./Screensavers"
import ThemeSelector from "./ThemeSelector"
import WebBrowser from "./WebBrowser"

import test_smallicon from "../icons/circle_question-1.png";
import test_bigicon from "../icons/circle_question-0.png";

// import popupwindow_small from "../icons/msg_information-2.png"
import popupwindow_small from "../icons/circle_question-1.png"

import calculator_small from "../icons/calculator-1.png"
import calculator_big from "../icons/calculator-0.png"
import checkers_small from "../icons/users-1.png"
import checkers_big from "../icons/users-2.png"
import fileexplorer_small from "../icons/directory_open_file_mydocs-2.png"
import fileexplorer_big from "../icons/directory_open_file_mydocs-0.png"
import instructions_small from "../icons/help_book_small-1.png"
import instructions_big from "../icons/help_book_small-2.png"
import maps_small from "../icons/world-1.png"
import maps_big from "../icons/world-0.png"
import minesweeper_small from "../icons/game_mine_1-1.png"
import minesweeper_big from "../icons/game_mine_1-0.png"
import notepad_small from "../icons/notepad-0.png"
import notepad_big from "../icons/notepad-1.png"
import othello_small from "../icons/joystick_alt-1.png"
import othello_big from "../icons/joystick_alt-0.png"
import paint_small from "../icons/paint_file-0.png"
import paint_big from "../icons/paint_file-2.png"
import pathfinder_small from "../icons/tree-1.png"
import pathfinder_big from "../icons/tree-0.png"
import pokemon_small from "../icons/cable_2-1.png"
import pokemon_big from "../icons/cable_2-0.png"
import screensaver_small from "../icons/standby_monitor_moon-1.png"
import screensaver_big from "../icons/standby_monitor_moon-4.png"
import themeselector_small from "../icons/monitor_blue_grad-1.png"
import themeselector_big from "../icons/monitor_blue_grad-0.png"
import webbrowser_small from "../icons/internet_connection_wiz-1.png"
import webbrowser_big from "../icons/internet_connection_wiz-0.png"

export const allApplications = [

  // secondary windows/windows opened by other windows
  {name: "Popup Window",
    component: PopupWindow,
    windowType: "Secondary",
    smallIcon: popupwindow_small,
    bigIcon: test_bigicon,
    size: [250, 110]},

  {name: "New File",
    component: FileCreator,
    windowType: "Secondary",
    smallIcon: test_smallicon,
    bigIcon: test_bigicon,
    size: [300, 100]},

  {name: "Open File",
    component: FileOpener,
    windowType: "Secondary",
    smallIcon: test_smallicon,
    bigIcon: test_bigicon,
    size: [300, 200]},

  {name: "Save File",
    component: FileSaver,
    windowType: "Secondary",
    smallIcon: test_smallicon,
    bigIcon: test_bigicon,
    size: [300, 100]},

  // application windows
  {name: "Calculator",
    component: Calculator,
    windowType: "Application",
    smallIcon: calculator_small,
    bigIcon: calculator_big,
    size: [250, 300]},

  {name: "Checkers",
    component: Checkers,
    windowType: "Application",
    smallIcon: checkers_small,
    bigIcon: checkers_big,
    size: [250, 300]},

  {name: "File Explorer",
    component: FileExplorer,
    windowType: "Application",
    smallIcon: fileexplorer_small,
    bigIcon: fileexplorer_big,
    size: [250, 300]},

  {name: "Game Instructions",
    component: Help,
    windowType: "Application",
    smallIcon: instructions_small,
    bigIcon: instructions_big,
    size: [250, 300]},

  {name: "Maps",
    component: Maps,
    windowType: "Application",
    smallIcon: maps_small,
    bigIcon: maps_big,
    size: [700, 500]},

  {name: "Minesweeper",
    component: Minesweeper,
    windowType: "Application",
    smallIcon: minesweeper_small,
    bigIcon: minesweeper_big,
    size: [400, 400]},

  {name: "Notepad",
    component: Notepad,
    windowType: "Application",
    smallIcon: notepad_small,
    bigIcon: notepad_big,
    size: [400, 500]},

  {name: "Othello",
    component: Othello,
    windowType: "Application",
    smallIcon: othello_small,
    bigIcon: othello_big,
    size: [250, 300]},

  {name: "Paint",
    component: Paint,
    windowType: "Application",
    smallIcon: paint_small,
    bigIcon: paint_big,
    size: [500, 400]},

  {name: "Pathfinder",
    component: Pathfinder,
    windowType: "Application",
    smallIcon: pathfinder_small,
    bigIcon: pathfinder_big,
    size: [500, 400]},

  {name: "Pokemon Finder",
    component: PokemonFinder,
    windowType: "Application",
    smallIcon: pokemon_small,
    bigIcon: pokemon_big,
    size: [325, 200]},

  {name: "Screensaver Preview",
    component: Screensavers,
    windowType: "Application",
    smallIcon: screensaver_small,
    bigIcon: screensaver_big,
    size: [500, 400]},

  {name: "Theme Selector",
    component: ThemeSelector,
    windowType: "Application",
    smallIcon: themeselector_small,
    bigIcon: themeselector_big,
    size: [250, 36 * 4]},

  {name: "Web Browser",
    component: WebBrowser,
    windowType: "Application",
    smallIcon: webbrowser_small,
    bigIcon: webbrowser_big,
    size: [600, 400]},

];
